import { PagedSearch } from '../../shared/model/paged-search.model';

export class ProfileSearchParams extends PagedSearch {
  public Keyword: string;
  public RestrictToOrganization: boolean;
  public RestrictToIndividual: boolean;
  public RestrictToMember: boolean;
  public RestrictToActive: boolean;
  public RestrictToProspect: boolean;
  public ProfileTypeId: number;
  public ProspectsForUserNum: number;
  public SoldByUserNum: number;
  public AssignedToUserNum: number;
  public RestrictToChanged: boolean;
  public DateChangedStartDate: Date;
  public DateChangedEndDate: Date;
  public City: string;
  public State: string;
  public Zip: string;
  public RelatedProfileId: number;
  public PrimaryRelationsOnly: boolean;
  public Email: string;

  public constructor() {
    super();

    this.Keyword = '';
    this.RestrictToOrganization = false;
    this.RestrictToIndividual = false;
    this.RestrictToMember = false;
    this.RestrictToActive = true;
    this.RestrictToProspect = false;
    this.ProfileTypeId = 0;
    this.ProspectsForUserNum = 0;
    this.SoldByUserNum = 0;
    this.AssignedToUserNum = 0;
    this.RestrictToChanged = false;
    this.DateChangedStartDate = new Date();
    this.DateChangedEndDate = new Date();
    this.City = '';
    this.State = '';
    this.Zip = '';
    this.RelatedProfileId = 0;
    this.PrimaryRelationsOnly = true;
    this.Email = '';
  }
}
